module.exports = __webpack_public_path__ + "static/media/window-minimize.a1b925d7.svg";